import { Headphones, MessageCircle } from 'lucide-react';

interface HelpFallbackSupportProps {
  onContactSupport: () => void;
}

export function HelpFallbackSupport({ onContactSupport }: HelpFallbackSupportProps) {
  return (
    <div className="mb-1 mt-5 rounded-lg bg-surface-2 px-4 py-5 text-center">
      <div className="mx-auto mb-2.5 flex h-9 w-9 items-center justify-center rounded-full border border-muted bg-surface-0 text-tertiary">
        <Headphones className="h-4 w-4" />
      </div>
      <p className="mb-0.5 text-ui-sm font-semibold text-secondary">
        ¿No encontraste lo que buscabas?
      </p>
      <p className="mb-3.5 text-label text-muted">
        Nuestro equipo puede ayudarte directamente.
      </p>
      <button
        type="button"
        onClick={onContactSupport}
        className="inline-flex items-center gap-1.5 rounded-full border bg-surface-0 px-4 py-2 text-caption-medium text-secondary transition-colors hover:border-strong hover:bg-surface-hover"
      >
        <MessageCircle className="h-3.5 w-3.5" />
        Contactar soporte
      </button>
    </div>
  );
}
